import React from 'react';
import { Table } from 'antd';
import moment from 'moment';
import styles from './index.module.scss';

const ExportLog = ({ data, loading }) => {
  const renderStatus = (value, row) => {
    switch (value) {
      case 1:
        return <span className={styles.pending}>导出中...</span>;
      case 2:
        return (
          <a className={styles.success} href={row.fileUrl} download>
            保存到本地
          </a>
        );
      case 3:
        return <span className={styles.fail}>{row.failReason || '导出失败'}</span>;
      default:
        return null;
    }
  };
  const columns = [
    {
      dataIndex: 'title',
      key: 'title',
      width: 200,
    },
    {
      dataIndex: 'createTime',
      key: 'createTime',
      render: (value) => moment.unix(value).format('YYYY-MM-DD HH:mm:ss'),
      width: 100,
    },
    {
      dataIndex: 'status',
      key: 'status',
      render: renderStatus,
      width: 100,
    },
  ];
  return (
    <Table
      columns={columns}
      dataSource={data}
      rowKey={(row) => row.taskId}
      className={styles.exportLog}
      showHeader={false}
      pagination={false}
      loading={loading}
    />
  );
};

export default ExportLog;
